import React, { useState } from 'react'
import SearchBar from '../SearchBar/SearchBar'
import './OverviewSearch.scss'

export default function OverviewSearch(props) {
    const searchType = {
        commodity: 'commodity',
        county: 'county'
    }

    const [toggled, setToggled] = useState(true)

    const handleToggleCounty = () => {
        setToggled(true)
        props.sendToParent(searchType.county)
    }
    const handleToggleCommodity = () => {
        setToggled(false)
        props.sendToParent(searchType.commodity)
    }

    return(
        <>
         <div>
             <button className={toggled ? 'active': null} onClick={handleToggleCounty}>Search by County</button>
             <button className={toggled ? null:'active'} onClick={handleToggleCommodity}>Search by Commodity</button>
             {
             toggled
             ? <SearchBar searchType={searchType.county} placeholder='Find A County' />
             : <SearchBar searchType={searchType.commodity} placeholder='Find A Commodity' />
             }
        </div>   
        </>
    )
}